import { hasValue } from '@r-and-a-shared-ui/utils';
import { isRelationFulfilled } from 'libs/common-kontent-client/src/utils/helpers/relationComparisonHelpers';
import type { FormFieldProps } from '../fields/FormField/FormField';

export const shouldHideFieldByDependency = (
  fieldProps: FormFieldProps,
  watchedValues: Record<string, any> | undefined,
): boolean => {
  const displayHideFieldRules =
    fieldProps.displayHideFieldBasedOnOtherFieldsValue || [];

  return (
    displayHideFieldRules.length > 0 &&
    displayHideFieldRules.every(rule => {
      const dependsOnFieldKey = rule?.key;
      const dependsOnFieldValue = dependsOnFieldKey
        ? watchedValues?.[dependsOnFieldKey]
        : undefined;

      return (
        !hasValue(dependsOnFieldValue) ||
        !isRelationFulfilled(dependsOnFieldValue, rule.item)
      );
    })
  );
};
